import React from 'react';

function formatNumber(value) {
  return new Intl.NumberFormat('de-DE').format(Number(value || 0));
}

export function EventStatsWidget({ stats = null }) {
  const items = [
    { label: 'Punkte', value: stats?.total_points },
    { label: 'Meldungen', value: stats?.reports_count },
    { label: 'Abholungen', value: stats?.collected_count },
    { label: 'Crew', value: stats?.active_participants },
  ];

  return (
    <div className="pfp-event-stats">
      {items.map((item) => (
        <div className="pfp-event-stat" key={item.label}>
          <strong>{formatNumber(item.value)}</strong>
          <span>{item.label}</span>
        </div>
      ))}
    </div>
  );
}

export default EventStatsWidget;
